import { Component, Host, h, Prop, State, Listen, Element } from '@stencil/core';

@Component({
  tag: 'lilu-energy-label',
  styleUrl: 'lilu-energy-label.scss',
  shadow: true,
})
export class LiluEnergyLabel {
  @Prop() imgPath: string;
  @Prop() imgAlt: string;

  @Prop() bigImgPath: string;
  @Prop() bigImgAlt: string;

  @Prop() appearance: string = null;

  @Element() el: HTMLElement;
  @State() isDesktop = false;

  tooltip: HTMLElement;

  componentWillLoad() {
    this.isDesktop = window.innerWidth >= 992;
  }

  @Listen('resize', { target: 'window' })
  onResize() {
    this.isDesktop = window.innerWidth >= 992;
  }

  getOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY,
    };
  }

  getShadowRootTooltip(): HTMLElement {
    return this.tooltip.shadowRoot.querySelector('.tooltip');
  }

  onClick() {
    if (!this.tooltip) {
      this.tooltip = this.el.shadowRoot.querySelector('lilu-energy-tooltip');
    }

    if (this.tooltip) {
      this.tooltip.style.display = 'flex';
      this.el.closest('.page-wrapper').append(this.tooltip);
    }
  }

  onMouseOver() {
    if (this.isDesktop) {
      const offset = this.getOffset(this.el.shadowRoot.querySelector('.energy-label'));

      if (!this.tooltip) {
        this.tooltip = this.el.shadowRoot.querySelector('lilu-energy-tooltip');
      }

      if (this.tooltip) {
        if (this.isDesktop) {
          const shadowRootTooltip = this.getShadowRootTooltip();
          shadowRootTooltip.style.top = offset.top + 'px';
          shadowRootTooltip.style.left = offset.left + 'px';
          shadowRootTooltip.classList.remove('left', 'right');
          shadowRootTooltip.classList.add(this.getOrientation());
          this.tooltip.style.display = 'block';
        } else {
          this.tooltip.style.display = 'flex';
        }

        this.el.closest('.page-wrapper').append(this.tooltip);
      }
    }
  }

  onMouseLeave() {
    if (this.isDesktop && this.tooltip) {
      this.tooltip.style.display = 'none';
    }
  }

  getOrientation() {
    const box = this.el.getBoundingClientRect();
    const width = 300; // tooltip width. It is initialy not rendered, so we don't know the size.
    // Check if right side has enough space to display
    if (box.left + width < window.innerWidth) {
      return 'right';
    } else {
      return 'left';
    }
  }

  render() {
    return (
      <Host onClick={this.onClick.bind(this)} onMouseOver={this.onMouseOver.bind(this)} onMouseLeave={this.onMouseLeave.bind(this)}>
        <div class={`energy-label ${this.appearance ? this.appearance : ''} ${this.bigImgPath ? '' : 'no-tooltip'}`}>
          <img loading="lazy" src={`${this.imgPath}`} alt={`${this.imgAlt}`} />
          {this.bigImgPath ? <lilu-energy-tooltip img={`${this.bigImgPath}`} alt={`${this.bigImgAlt}`}></lilu-energy-tooltip> : ''}
        </div>
      </Host>
    );
  }
}
